import { ModelBase } from '@barthauer/abc/core/data';

export class ArenaModelBase extends ModelBase {
  ArenaName: string;
}

export class ReadNavigationModel extends ArenaModelBase {}

export class ReadMenuModel extends ArenaModelBase {}

export class ReadLayoutModel extends ArenaModelBase {
  LayoutId: string;
}
